export enum AuthorType {
    EVENT = 'event',
    SPORT = 'sport',
    TEAM = 'team'
}